<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
        >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"> </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import onlineDoc from '../components/onlineDoc'

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'tempCarTender/queryTenderSortNum'
export default {
  components: { onlineDoc },
  computed: {
    ...mapGetters(['token', 'uuid']),
    address() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : ''
    }
  },
  data() {
    return {
      mainStatus: 'online',
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: '与平台签约的客户，可通过此接口接收干线加班车招采的订单',
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'tenderNo',
                type: 'String(30)',
                require: 'Y',
                normal: '',
                describe: '需求编码'
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          },
          {
            title: 'data类型说明',
            value: [
              {
                name: 'tenderNo',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '需求编码'
              },
              {
                name: 'rankNum',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '排名'
              },
              {
                name: 'offerPrice',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '报价'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921
    Body：
    bizContent= {"tenderNo":"XQBM202408270006"}`,
        //返回示例
        responseCode: JSON.parse(`{
            "code": "1",
            "msg": "success",
            "data": {
              "tenderNo": "XQBM202408270006",
              "rankNum": "前三名",
              "offerPrice": 120
            }
          }
        `),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: '1001',
          digest: 'U40e5sumorgd3YgZzU61Mw==',
          timestamp: '1565238848921'
        },
        data: {
          bizContent: `{"offerPrice":120,"tenderNo":"XQBM202408270006","carrierContact":"y","carrierContactPhone":"17512341234","giveUpBid":1,"remarks":"","userName":"张三"}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: '',
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      }
    }
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
